import React from 'react';

import { Typography } from 'antd';
import styled from 'styled-components';

import { GroupType, GroupUserType } from 'types/groups';

const Container = styled.span`
  display: flex;
  flex-direction: column;
`;

const Count = styled.span`
  font-size: 12px;
  color: var(--text-secondary);
`;

interface Props {
  item: GroupType;
}

const GroupsTableUsers = ({ item }: Props) => {
  return (
    <Container>
      <Count>Total: {(item.users ?? []).length}</Count>
      <Typography.Paragraph
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          fontSize: 10,
          color: 'var(--text-secondary)',
          marginBottom: 0,
        }}
        ellipsis={{
          rows: 4,
          expandable: 'collapsible',
          symbol: (expanded: boolean) => (
            <div style={{ display: 'flex', color: 'var(--dark-blue)', fontSize: 10 }}>
              {expanded ? 'Show Less' : 'Show More'}
            </div>
          ),
        }}
      >
        {(item?.users ?? []).map((user: GroupUserType) => (
          <span key={user.id}>
            {user?.first_name?.length ? (
              <span>
                {user?.first_name ?? ''} {user?.last_name ?? ''}
              </span>
            ) : (
              <span>{user?.email || user.username}</span>
            )}
          </span>
        ))}
      </Typography.Paragraph>
    </Container>
  );
};

export default GroupsTableUsers;
